import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("categories", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("categorySwiper")
      ) {
        return {
          type: "categories",
        };
      }
    },
    model: {
      toHTML() {
        let rootElement = this.view?.el || this.getEl();
        if (!rootElement) return "";
        let outerHTML = rootElement.outerHTML;
        let Type = this.getAttributes().type;
        if (!Type) {
          return outerHTML;
        }
        outerHTML = outerHTML.replace(
          /<!--\s*{%\s*categories\s+.*?\s+as\s+categories_dict\s*%}\s*-->/,
          `{% categories '${Type}' as categories_dict %}`
        );
        return outerHTML;
      },

      defaults: {
        traits: [
          {
            type: "select",
            label: "Type",
            name: "type",
            options: [
              { id: "category", name: "Category" },
              { id: "product_type", name: "Product Type" },
            ],
          },
        ],
        Type: "",
        components: /*html*/ `<section class="bg-gray-100  px-4">
          <div class="mx-auto container swiper categorySwiper ">
            <div class="swiper-wrapper md:p-4 py-2 ">
              <!-- {% categories 'type' as categories_dict %} -->

              <!-- {% for category in categories_dict.categories %} -->
              <!-- {% comment %} -->
              <a href="" class="swiper-slide ripple-effect relative overflow-hidden">
                <!-- {% endcomment %} -->
                <!--  <a href="{{ category.absolute_url }}" class="swiper-slide "> -->
                <div class="flex flex-col items-center justify-center">
                  <div
                    class="md:rounded-full rounded-lg w-18 h-18 md:w-32 md:h-32 overflow-hidden"
                  >
                    <!-- {% comment %} -->
                    <img
                      src="https://via.placeholder.com/100"
                      alt="Category_img"
                      class="w-full h-full md:rounded-full object-cover md:p-2"
                    />
                    <!-- {% endcomment %} -->
                    <!-- <img
                        src="{% generate_thumbnail category.image_url '150x150/filters:format(webp)' %}"
                        alt="{{ category.name }}"
                        class="w-full h-full md:rounded-full object-cover md:p-2"/> -->
                  </div>

                  <h3 class="hidden md:block font-semibold text-lg text-center">
                    <!-- {% comment %} -->
                    Men's Wearing hat

                    <!-- {% endcomment %} -->
                    <!-- {{ category.name }} -->
                  </h3>
                </div>
              </a>
              <!-- {% endfor %} -->
              <!-- {% comment %} -->
              <a href="#" class="swiper-slide ripple-effect relative overflow-hidden ">
                <div class="flex flex-col items-center justify-center">
                  <div
                    class="md:rounded-full rounded-lg w-18 h-18 md:w-32 md:h-32 overflow-hidden"
                  >
                    <img
                      src="https://via.placeholder.com/100"
                      alt="Category_img"
                      class="w-full h-full md:rounded-full object-cover md:p-2"
                    />
                  </div>
                  <h3 class="hidden md:block font-semibold text-lg text-center">
                    Men's Wear 1
                  </h3>
                </div>
              </a>
              <a href="#" class="swiper-slide ripple-effect relative overflow-hidden">
                <div class="flex flex-col items-center justify-center">
                  <div
                    class="md:rounded-full rounded-lg w-18 h-18 md:w-32 md:h-32 overflow-hidden"
                  >
                    <img
                      src="https://via.placeholder.com/100"
                      alt="Category_img"
                      class="w-full h-full md:rounded-full object-cover md:p-2"
                    />
                  </div>
                  <h3 class="hidden md:block font-semibold text-lg text-center">
                    Men's Wear 2
                  </h3>
                </div>
              </a>
              <a href="#" class="swiper-slide ripple-effect relative overflow-hidden">
                <div class="flex flex-col items-center justify-center">
                  <div
                    class="md:rounded-full rounded-lg w-18 h-18 md:w-32 md:h-32 overflow-hidden"
                  >
                    <img
                      src="https://via.placeholder.com/100"
                      alt="Category_img"
                      class="w-full h-full md:rounded-full object-cover md:p-2"
                    />
                  </div>
                  <h3 class="hidden md:block font-semibold text-lg text-center">
                    Men's Wear 3
                  </h3>
                </div>
              </a>
              <a href="#" class="swiper-slide ripple-effect relative overflow-hidden">
                <div class="flex flex-col items-center justify-center">
                  <div
                    class="md:rounded-full rounded-lg w-18 h-18 md:w-32 md:h-32 overflow-hidden"
                  >
                    <img
                      src="https://via.placeholder.com/100"
                      alt="Category_img"
                      class="w-full h-full md:rounded-full object-cover md:p-2"
                    />
                  </div>
                  <h3 class="hidden md:block font-semibold text-lg text-center">
                    Men's Wear 4
                  </h3>
                </div>
              </a>
              <a href="#" class="swiper-slide ripple-effect relative overflow-hidden">
                <div class="flex flex-col items-center justify-center">
                  <div
                    class="md:rounded-full rounded-lg w-18 h-18 md:w-32 md:h-32 overflow-hidden"
                  >
                    <img
                      src="https://via.placeholder.com/100"
                      alt="Category_img"
                      class="w-full h-full md:rounded-full object-cover md:p-2"
                    />
                  </div>
                  <h3 class="hidden md:block font-semibold text-lg text-center">
                    Men's Wear 5
                  </h3>
                </div>
              </a>
              <a href="#" class="swiper-slide ripple-effect relative overflow-hidden">
                <div class="flex flex-col items-center justify-center">
                  <div
                    class="md:rounded-full rounded-lg w-18 h-18 md:w-32 md:h-32 overflow-hidden"
                  >
                    <img
                      src="https://via.placeholder.com/100"
                      alt="Category_img"
                      class="w-full h-full md:rounded-full object-cover md:p-2"
                    />
                  </div>
                  <h3 class="hidden md:block font-semibold text-lg text-center">
                    Men's Wear 6
                  </h3>
                </div>
              </a>
              <a href="#" class="swiper-slide ripple-effect relative overflow-hidden">
                <div class="flex flex-col items-center justify-center">
                  <div
                    class="md:rounded-full rounded-lg w-18 h-18 md:w-32 md:h-32 overflow-hidden"
                  >
                    <img
                      src="https://via.placeholder.com/100"
                      alt="Category_img"
                      class="w-full h-full md:rounded-full object-cover md:p-2"
                    />
                  </div>
                  <h3 class="hidden md:block font-semibold text-lg text-center">
                    Men's Wear 7
                  </h3>
                </div>
              </a>
              <!-- {% endcomment %} -->
            </div>
          </div>
        </section> `,
        init() {
          this.on("change:attributes:type", this.handleSelect);
        },
        handleSelect() {
          this.addAttributes({ Type: this.getAttributes().type });
        },
        script: function () {
          const initLib = function () {
            //@ts-ignore
            const swiper = new Swiper(".categorySwiper", {
              slidesPerView: 4,
              spaceBetween: 10,
              freeMode: true,
              mousewheel: true,
              keyboard: true,
              breakpoints: {
                640: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 5,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 6,
                  spaceBetween: 10,
                },
              },
            });
          };
          //@ts-ignore
          if (typeof Swiper === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
